import { Navigate, useLocation } from "react-router-dom"
import { ResultLayout } from "../components/layouts"
import { IEstimates } from "../features/platform"
import { Estimates } from "../features/platform_result"

const DISCLAIMERS = [
  "※このシミュレーション結果は、ジョーシス「有料プラン」をご利用いただいた場合を想定しております。",
  "※デバイスの購入後の配送や回収時に発生する送料なども含まれております。",
  "※情シス正社員コストは、国税庁発表「令和3年分民間給与実態統計調査」に基づき、正社員平均年収508万円を採用しております。",
]

const PlatformResult = () => {
  const location = useLocation()
  const state = location.state

  if (!state) {
    return <Navigate to="/" />
  }

  const { simulationResults } = state as { simulationResults: IEstimates }

  return (
    <ResultLayout disclaimers={DISCLAIMERS}>
      <Estimates results={simulationResults} />
    </ResultLayout>
  )
}
export { PlatformResult }
